module.exports = __webpack_public_path__ + "static/media/star_disabled.5ca236ab.svg";